<div class="carousel-wrapper">
    <!-- carousel -->
    <owl-carousel-o #owlCar [options]="customOptions" #carousel>
        @for (product of products(); track product?.url_path) {
        <ng-template carouselSlide>
            <a [routerLink]="[]" class="router-link">
                <a [routerLink]="['/products/' + product?.url_path]" class="router-link">
                    <webstore-related-products-card [product]="product"></webstore-related-products-card>
                </a>
            </a>
        </ng-template>
        }
    </owl-carousel-o>

    <!-- navigation button -->
    <button class="prev-btn" type="button" (click)="owlCar.prev()">Prev</button>
    <button class="next-btn" type="button" (click)="owlCar.next()">Next</button>
</div>